export const primaryColor = '#7c3088';
export const secondaryColor = '#00a0df';